import { Gift, Sparkles } from "lucide-react";
import { formatCLP } from "../lib/api";
import { useSiteSettings } from "../hooks/useSiteSettings";

export default function GiftThermometer({ total }) {
    const { settings } = useSiteSettings();
    const threshold = Number(settings?.gift_threshold) > 0 ? Number(settings.gift_threshold) : 20000;
    const pct = Math.min(100, (total / threshold) * 100);
    const remaining = Math.max(0, threshold - total);
    const won = total >= threshold;

    return (
        <div
            data-testid="gift-thermometer"
            className={`rounded-2xl p-3 border-2 ${
                won
                    ? "bg-marigold/10 border-marigold"
                    : "bg-mexyellow/15 border-mexyellow"
            }`}
        >
            <div className="flex items-center gap-2 mb-2">
                {won ? (
                    <>
                        <Sparkles className="w-5 h-5 text-marigold animate-wobble" />
                        <span className="font-display font-semibold text-marigold text-sm">
                            ¡Ganaste un regalo sorpresa! 🎁
                        </span>
                    </>
                ) : (
                    <>
                        <Gift className="w-5 h-5 text-marigold" />
                        <span className="font-display font-semibold text-cocoa text-sm">
                            Te faltan{" "}
                            <span data-testid="thermometer-remaining" className="text-cocoa">
                                {formatCLP(remaining)}
                            </span>{" "}
                            para tu regalo
                        </span>
                    </>
                )}
            </div>
            <div className="relative h-3 bg-white rounded-full overflow-hidden shadow-inner">
                <div
                    data-testid="thermometer-bar"
                    className={`h-full rounded-full transition-all duration-500 ease-out ${
                        won
                            ? "bg-gradient-to-r from-marigold to-mexyellow"
                            : "bg-gradient-to-r from-mexred via-marigold to-mexyellow"
                    }`}
                    style={{ width: `${pct}%` }}
                />
                {!won && pct > 0 && (
                    <div
                        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 transition-all duration-500"
                        style={{ left: `${pct}%` }}
                    >
                        <span className="text-base">🌶️</span>
                    </div>
                )}
            </div>
            <div className="flex justify-between mt-1 text-xs text-muted-foreground">
                <span>{formatCLP(total)}</span>
                <span>Meta: {formatCLP(threshold)}</span>
            </div>
        </div>
    );
}
